import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
    selector: 'app-print',
    templateUrl: './print.component.html',
    styleUrls: ['./print.component.css'],
    standalone: false
})
export class PrintComponent implements OnInit {
  token: any;

  invoice: any = {};
  package: any = null;

  date: any;

  constructor(private route: ActivatedRoute, private api: ApiService, private titleService: Title, public utility: UtilitiesService) {
    this.utility.show = false;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'];
      let appointment_id = params['appointment_id'];
      let client_id = params['client_id'];

      if (id)
        this.getInvoice(id);

      if (appointment_id && client_id)
        this.getInvoice_by_appointment(client_id, appointment_id);
    });
  }

  ngAfterViewInit(): void {
    window.print();
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  getInvoice(id: any) {
    this.api.get('payments/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.invoice = objects.payments[0];

        if (this.invoice?.payment_details?.package)
          this.package = this.invoice.payment_details.package;

        const title = this.invoice?.details?.patient_number;
        if (title) this.setTitle(title);
      },
      async error => { }
    );
  }

  getInvoice_by_appointment(client_id: any, appointment_id: any) {
    this.api.get('payments/client/' + client_id + '/' + appointment_id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.invoice = objects.payments[0];

        const title = this.invoice?.details?.patient_number;
        if (title) this.setTitle(title);
      },
      async error => { }
    );
  }
}
